module.exports = __webpack_public_path__ + "img/1119.cda71d44.jpg";